import { ReactNode } from 'react';
import IconButton from '@mui/material/IconButton';
import ButtonMui, { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

export type ButtonProps = {
  children?: ReactNode;
  loading?: boolean;
  fullWidthMobile?: boolean;
  iconButton?: boolean;
  target?: string;
  component?: any;
} & MuiButtonProps;

export const Button: React.FC<ButtonProps> = ({
  children,
  loading = false,
  fullWidthMobile = false,
  iconButton = false,
  ...props
}: ButtonProps) => {
  if (iconButton) {
    return (
      <IconButton
        {...props}
        sx={(theme) =>
          ({
            [theme.breakpoints.down('sm')]: {
              width: fullWidthMobile || props.fullWidth ? '100%' : 'auto',
            },
            border: '1px solid',
            borderColor: '#0f132a80',
            borderRadius: 1,
            color: '#0F132A',
            ...props?.sx,
          } as any)
        }
      >
        {loading ? (
          <CircularProgress
            data-test-id="loading-button"
            size={props.size === 'large' ? 20 : 16}
          />
        ) : (
          children
        )}
      </IconButton>
    );
  }

  return (
    <ButtonMui
      {...props}
      sx={(theme) => ({
        [theme.breakpoints.down('sm')]: {
          width: fullWidthMobile || props.fullWidth ? '100%' : 'auto',
        },
        ...(props.sx || {}),
      })}
      endIcon={
        loading ? (
          <CircularProgress
            data-test-id="loading-button"
            size={props.size === 'large' ? 20 : 16}
          />
        ) : (
          props.endIcon
        )
      }
      disabled={props.disabled || loading}
    >
      {children}
    </ButtonMui>
  );
};

export default Button;
